import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './DownloadBar.pcss';
import LoadingBar from '../loading-bar/LoadingBar';
import {downloads, CustomPropShapes} from '../../constants';

class DownloadBar extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        percent: PropTypes.number,
        status: CustomPropShapes.oneOfConstant(downloads.states).isRequired
    };
    render() {
        const {className, percent, status} = this.props;
        const barClasses = cx({
            [styles.error]: status === downloads.states.ERROR,
            [styles.inactive]: status === downloads.states.INACTIVE
        });
        return (
            <div className={cx(styles.main, className)}>
                <LoadingBar foregroundClass={barClasses} hasPlaceholder percent={percent} />
            </div>
        );
    }
}

export default DownloadBar;
